var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketingBusinessCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67 0H4C1.79086 0 0 1.79086 0 4V67C0 69.2091 1.79086 71 4 71H67C69.2091 71 71 69.2091 71 67V4C71 1.79086 69.2091 0 67 0Z",
    fill: "#7209B7",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.25 21H20.0833C17.8317 21 16 22.7584 16 24.92V45.08C16 47.2416 17.8317 49 20.0833 49H49.25C51.5017 49 53.3333 47.2416 53.3333 45.08V24.92C53.3333 22.7584 51.5017 21 49.25 21ZM27.9583 26.04C30.3733 26.04 32.3333 27.9216 32.3333 30.24C32.3333 32.5584 30.3733 34.44 27.9583 34.44C25.5433 34.44 23.5833 32.5584 23.5833 30.24C23.5833 27.9216 25.5433 26.04 27.9583 26.04ZM34.025 43.96H21.915C20.8732 43.96 20.025 43.083 20.1767 42.0448C20.725 38.3488 24.0733 35.56 27.97 35.56C31.855 35.56 35.2033 38.3488 35.7517 42.0448C35.9045 43.0931 35.0388 43.96 34.025 43.96ZM43.4167 37.8H39.3333C38.365 37.8 37.5833 37.0496 37.5833 36.12C37.5833 35.1904 38.365 34.44 39.3333 34.44H43.4167C44.385 34.44 45.1667 35.1904 45.1667 36.12C45.1667 37.0496 44.385 37.8 43.4167 37.8ZM47.5 32.76H39.3333C38.365 32.76 37.5833 32.0096 37.5833 31.08C37.5833 30.1504 38.365 29.4 39.3333 29.4H47.5C48.4683 29.4 49.25 30.1504 49.25 31.08C49.25 32.0096 48.4683 32.76 47.5 32.76Z",
    fill: "#7209B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingBusinessCard);
export default __webpack_public_path__ + "static/media/marketing-business-card.6c4a894039c051ffcd3cc1e184c437bb.svg";
export { ForwardRef as ReactComponent };